// Swiper carousel functionality
// Import Swiper and required modules
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Thumbs } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';

// Initialize Swiper instances
document.addEventListener('DOMContentLoaded', () => {
  // Hero carousel with fade effect
  const heroCarousel = new Swiper('.hero-carousel', {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    effect: 'fade',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: true,
  });

  // Testimonials carousel
  const testimonialsCarousel = new Swiper('.testimonials-carousel', {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.testimonials-button-next',
      prevEl: '.testimonials-button-prev',
    },
    pagination: {
      el: '.testimonials-pagination',
      clickable: true,
    },
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  // Team carousel
  const teamCarousel = new Swiper('.team-carousel', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.team-button-next',
      prevEl: '.team-button-prev',
    },
    pagination: {
      el: '.team-pagination',
      clickable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });

  // Cases carousel with thumbnails
  const casesCarouselThumbs = new Swiper('.cases-carousel-thumbs', {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 10,
    navigation: {
      nextEl: '.cases-thumbs-next',
      prevEl: '.cases-thumbs-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
    },
  });

  const casesCarousel = new Swiper('.cases-carousel', {
    modules: [Navigation, Pagination, Thumbs],
    navigation: {
      nextEl: '.cases-button-next',
      prevEl: '.cases-button-prev',
    },
    pagination: {
      el: '.cases-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: casesCarouselThumbs,
    },
  });
});
